<template lang="pug">
div.default-bg.fill-height
    v-navigation-drawer(
        v-model="drawer"
        app
        color="drawer"
        dark
        :width="drawerWidth"
        touchless
        data-test="nav-drawer"
    )
      v-list
          v-list-item
              img(:src="require('@/assets/img/logo.svg')")
              //- v-list-item-subtitle {{ $store.state.user.current.username }}
      course-managment-menu(v-show="currentPerms.has(PERM.COURSE_MANAGMENT)" :nameToGo="$ROUTER_NAMES.COURSE_MANAGMENT")
      course-managment-menu(
        isCursussen
        v-show="currentPerms.has(PERM.COURSE_MANAGMENT)" 
        :nameToGo="$ROUTER_NAMES.CURSSUSEN"
        :title="'Cursussen'"
      )

      v-list-item(:to="{name: $ROUTER_NAMES.COURSE_MANAGMENT_ALL}" v-show="currentPerms.has(PERM.COURSE_MANAGMENT)" link).app-list__item
        v-list-item-icon
          v-icon mdi-note-text
        v-list-item-content Master Planning
      v-list-group(prepend-icon="mdi-home-account" v-show="currentPerms.has(PERM.CBR_ACCOUNTS)" ).app-list-child
        template(v-slot:activator)
          v-list-item-title CBR Accounts
        v-list-item(:to="{name: $ROUTER_NAMES.CBR_ACC}" v-show="currentPerms.has(PERM.CBR_ACCOUNTS)" link).app-list__item
          v-list-item-content Overview
        v-list-item(:to="{name: $ROUTER_NAMES.CBR_ACC_AVALIABLE}" v-show="currentPerms.has(PERM.CBR_ACCOUNTS)" link).app-list__item
          v-list-item-content Avaliability 
      v-list

        v-list-item(:to="{name: $ROUTER_NAMES.SLOTS}" v-show="currentPerms.has(PERM.SLOTS)" link).app-list__item
          v-list-item-icon
            v-icon mdi-clipboard-outline
          v-list-item-content Slots
        v-list-item(:to="{name: $ROUTER_NAMES.RESULTS}" v-show="currentPerms.has(PERM.RESULTS)" link).app-list__item
          v-list-item-icon
            v-icon mdi-check-circle
          v-list-item-content Results
          
        v-list-item(:to="{name: $ROUTER_NAMES.COURSE_LEADERS}" v-show="currentPerms.has(PERM.CANDIDATES)" link).app-list__item
          v-list-item-icon
            v-icon mdi-account-voice
          v-list-item-content Course Leaders

        v-list-item(:to="{name: $ROUTER_NAMES.DRIVING_SCHOOLS}"  v-show="currentPerms.has(PERM.DRIVING_SCHOOLS)" link).app-list__item
          v-list-item-icon
            v-icon mdi-school-outline
          v-list-item-content Driving Schools

        v-list-group(prepend-icon="mdi-account-group" v-show="currentPerms.has(PERM.CANDIDATES)" v-model="locationsShowing").app-list-child
          template(v-slot:activator)
            v-list-item-title Candidates
          
          portal-target(name="candidate-location-menu" ref="candidateLocation")
            slot(v-if="!candidateLocationPortalActive")
              v-list-item(:to="{name: $ROUTER_NAMES.CANDIDATES}" link ).app-list-child__item
                v-list-item-content All
              v-list-item(v-for="location in this.crmCourseLocation" :key="location.ID" link
                @click="goToCandidates(location.id)"
                :class="{'v-list-item--active': $route.query.city === location.ID}"
              ).app-list-child__item
                v-list-item-content {{ location.name }}
    
    v-app-bar(app color='primary' dark :extension-height="extHeight")
        v-btn(icon @click="drawerToggle" data-test="drawer-btn") 
            v-icon $vuetify.icons.hamburger
        portal-target(name="toolbar")
        //- v-btn(text large) Nutheory-crm
        v-spacer
        template(v-slot:extension)
          portal-target(name="toolbar-extension" ref="portalExtension" slim)
        
        user-menu
        
    v-content
        router-view
    
</template>

<script>
import Vue from "vue"
import {mapGetters, mapMutations, mapActions} from "vuex"
import store from "@/store"

import auth from "@/services/CRMinitAuth"
import {DRAWER_WIDTH, CRM_PERMS, VIEWPORTS} from "@/util/const"
import CrmPerms from "@/app/admin/models/crmPerms"
import RouterNames from "./router/router-const"

const state = Vue.observable({
  perms: null
})

export default {
  async beforeRouteEnter(to, from, next) {
    try {
      await store.dispatch('user/current')
      let {crmSuperUser, crmAvaliablePerms} = store.getters['user/current']
      state.perms = new CrmPerms({
        superUser: crmSuperUser,
        avaliablePerms: crmAvaliablePerms
      })
      if(!crmAvaliablePerms) {
        next()
        return
      }
      if(state.perms.has(to.name) || state.perms.has(to.meta.perms)) {
        next() 
        return
      } 
      
      next({name: crmAvaliablePerms[0]})
      return    
    } catch (res) {
      if (res.error.code == 401 || res.error.code !== 403) {
        next({
          name: RouterNames.LOGIN_EXERCISE,
          query: { returnURL: to.name }
        });
        return
      }
      
      next({name: RouterNames.SERVER_ERROR})
    }
    
  },

  metaInfo() {
    return {
      meta: [
        { vmid: 'viewport-main', name: 'viewport', content: this.isIos ? VIEWPORTS.SCALED_IOS : VIEWPORTS.SCALED }
      ]
    }
  },

  name: 'DefaultLayout',

  data: () => ({
    drawer: false,
    extHeight: 0,
    candidateLocationPortalActive: false,
    drawerWidth: DRAWER_WIDTH,
    locationsShowing: true,
    PERM: CRM_PERMS,
    perms: state.perms
  }),

  computed: {
    ...mapGetters({
      crmCourseLocation: 'crmCourseCities/items'
    }),

    currentPerms() {
      if(!this.perms) return {
        has: () => false
      }
      return this.perms
    },

    isIos() {
      const userAgent = window.navigator.userAgent;
      return userAgent.match(/iPad/i) || userAgent.match(/iPhone/i);
    }
  },

  mounted() {
    this.loadCourseCities({cache: true})
    this.extHeight = this.getExtHeight()
    this.$store.dispatch('crmCourseCities/listWithAdditionalInfo')
  },

  methods: {
    ...mapMutations({
      setDrawerStatus: 'crmDrawer/set',
      clearCurrentUser: 'user/clear'
    }),
    ...mapActions({
      loadCourseCities: 'crmCourseCities/list',
      getCurrentUserInfo: 'user/current'
    }),

    async logout() {
      auth.logout()
      this.clearCurrentUser()
      this.redirectToAuth()
    },

    redirectToAuth() {
      this.$router.push({name: this.$ROUTER_NAMES.LOGIN_EXERCISE})
    },

    getExtHeight() {
      if(!this.$refs.portalExtension) return 0
      let height = 0
      if(this.$refs.portalExtension.passengers.length) height = 48
      return height
    },

    getCandidateLocationPortalStatus() {
      if(!this.$refs.candidateLocation) return false
      if(this.$refs.candidateLocation.passengers.length) return true
      return false
    },
    

    goToCandidates(location) {
      this.$router.push({name: this.$ROUTER_NAMES.CANDIDATES, query: {city: location}})
    },

    setCandidateLocationPortalStatus() {
      if(!this.$refs.candidateLocation) return false
      if(this.$refs.portalExtension.passengers.length) return true
      return false
    },

    isCandidatesPage() {
      if(this.$route.name.includes('candidate')) return true
      return false
    },

    drawerToggle() {
      this.drawer = !this.drawer
      this.setDrawerStatus(this.drawer)
    }

  },

  provide() {
    return {
      logout: this.logout,
      perms: state.perms
    }
  },

  watch: {
    '$route.path'() {
      this.$nextTick()
        .then( () => {
          this.extHeight = this.getExtHeight()
          this.candidateLocationPortalActive = this.setCandidateLocationPortalStatus()
          // this.locationsShowing = this.isCandidatesPage()
        })
      
      
      
    }
  },
  components: {
    UserMenu: () => import("@/components/widget/UserSettings.vue"),
    courseManagmentMenu: () => import('@/app/admin/components/CMMenu.vue')
  }
};
</script>

<style lang="scss" scoped>
.menu-item::v-deep {
    text-transform: capitalize;
}
</style>
